import styled from 'styled-components';

export const AutoSuggestDropdownStyled = styled.div`
  position: relative;
  .body_autosuggest {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme, disabled }) =>
    disabled ? theme.COLORS.PURPLE_1 : theme.COLORS.GRAY_30};
    background: ${({ theme, disabled }) =>
    disabled ? theme.COLORS.GRAY_36 : theme.COLORS.WHITE_1};
    font-size: ${({ theme, fontSize }) =>
    fontSize ? fontSize : theme.FONT.SIZE.S16};
    border: 1px solid
      ${({ disabled, theme }) =>
    disabled ? theme.COLORS.GRAY_22 : theme.COLORS.GRAY_10};
    display: flex;
    align-items: center;
    border-radius: 8px;
    padding: 9px 16px;
    box-sizing: border-box;
    height: ${({ heightInput }) => (heightInput ? heightInput : '48px')};
    column-gap: 5px;
    cursor: pointer;

    .value_show {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
      display: flex;
      align-items: center;
      gap: 8px;
      &.txt_color {
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
    }

    .svg_d {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }

    &.open {
      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
      border-radius: 8px;
      border-bottom: none;
    }
  }

  .otp_show {
    width: calc(100% - 1.6px);
    min-width: ${({ minwidth }) => (minwidth ? minwidth : 'unset')};
    max-height: 232px;
    position: absolute;
    z-index: 2;
    margin-top: 4px;
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);

    &.down {
      top: 48px;
      border-radius: 8px;
    }

    &.up {
      bottom: 48px;
      border-radius: 8px ;
    }

    .group_opt_top {
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
      display: flex;
      flex-direction: column;
      align-items: center;

      .all_zone {
        padding: 9.6px 0;
        cursor: pointer;
        border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
        width: calc(100% - 20px);

        &:last-child {
          border-bottom: none;
        }

        &.select_all {
          background: ${({ theme }) => theme.COLORS.BLUE_32};
        }
      }
    }

    .render_opt {
      display: flex;
      flex-direction: column;
      padding: 6px 2px;
      max-height: 180px;

      .box_search {
        margin: 0 5px 12px 5px;
        position: relative;
        padding: 5.6px 12px;
        border-radius: 8px;
        border: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};

        .svg_search {
          display: flex;
          cursor: pointer;
          position: absolute;
          top: 8px;
          right: 8px;
        }

        .input_search {
          width: calc(100% - 25px);
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
          border: none;
          color: ${({ theme }) => theme.COLORS.GRAY_23};

          &::placeholder {
            color: ${({ theme }) => theme.COLORS.GRAY_30};
          }
        }
      }

   
      .opt_zone_box {
        margin: 0px 8px;
        overflow: auto;

        ::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        ::-webkit-scrollbar-thumb {
          background: #cccccc;
          border-radius: 50px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: #c2c2c2;
        }

        .opt_box {
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S16};
          border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
          cursor: pointer;
          min-height: 33.2px;
          display: flex;
          align-items: center;
          padding: 5px 4px;

          .lbl_opt {
            display: flex;
            overflow-wrap: anywhere;
            align-items: center;
            gap: 8px;
          }

          &:last-child {
            border-bottom: none;
          }

          &.select {
            background: ${({ theme }) => theme.COLORS.BLUE_32};
          }

          &:hover {
            background: ${({ theme }) => theme.COLORS.BLUE_32};
          }
        }
      }
    }
  }

  .icon_opt {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }

  .error {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.RED_3};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    padding-top: 2px;
  }


`;
